import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

export default function FullScreenLayout() {
  return (
    <Box data-testid="layout-fullscreen" sx={{ flex: 1, overflow: 'auto', p: 3 }}>
      <Outlet />
    </Box>
  );
}
